module.exports = __webpack_public_path__ + "static/img/mang.d45873a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mang.png
// module id = DPSg
// module chunks = 52